import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterializeModule } from 'angular2-materialize';
import { CustomerCreateUpdateComponent } from './component/customer-create-update/customer-create-update.component';
import { CustomerListComponent } from './component/customer-list/customer-list.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    MaterializeModule
  ],
  exports: [
    CustomerListComponent,
    CustomerCreateUpdateComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    CustomerListComponent,
    CustomerCreateUpdateComponent
  ]
})
export class CustomerModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/customer/customer.module.ts